var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarScheduled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.822 8.093V3.177a2 2 0 0 0-2-1.999H2a2 2 0 0 0-1.999 2v8.642a2 2 0 0 0 2 2h5.892",
    stroke: "#22272A"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#22272A",
    cx: 10.982,
    cy: 10.982,
    r: 4.018
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22272A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.079 8.79v2.207l-.893.894"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#22272A",
    strokeLinecap: "round",
    d: "M4.02 0v2.356M9.803 0v2.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22272A",
    d: "M3.25 6.848h1.625V5.223H3.25zM3.25 10.214h1.625V8.59H3.25zM6.152 6.848h1.625V5.223H6.152zM6.152 10.214l1.08-.035.545-1.59H6.152zM9.054 6.848h1.625V5.223H9.054z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarScheduled);
export default __webpack_public_path__ + "static/media/calendar-scheduled.4ce376037fc075e2c5e309dc42c25fe1.svg";
export { ForwardRef as ReactComponent };